"use client";
import styled from "../../../client-utils/styled/index.js";
import CardMenuItemAtom from "../../../components/atoms/CardMenuItem/index.js";
const coreComponentName = "SdbProfileMenuCard";
export const CardMenuItem = styled(CardMenuItemAtom, {
    name: coreComponentName,
    slot: "CardMenuItem",
})({
    minHeight: "56px",
});
